class DLProductPartListH extends HTMLElement {
    constructor() {
      super();
      this.items = [];
    }
  
    connectedCallback() {
      this.init();
      this.handleResize();
    }
  
  init() {
    this.items = Array.from(this.querySelectorAll('.dl-product-part-list-h-part'));
    this.content = this.querySelector('.dl-product-part-list-h');
    this.toggleBtn = this.querySelector('.dl-product-part-list-h-toggle-btn');

    if (this.toggleBtn) {
      this.toggleBtn.addEventListener('click', () => this.handleToggleClick());
    }

    // 初始化时隐藏超过5个的part
    this.initializeItems();
  }
  
    handleResize() {
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.recalculateExpandedItemsHeight();
        }, 150);
      });
    }
  
  
    handleToggleClick() {
      if (!this.content) return;
  
      const isAllVisible = this.content.dataset.allVisible === 'true';
  
      if (isAllVisible) {
        this.collapseExtraItems();
        this.content.dataset.allVisible = 'false';
      } else {
        this.content.dataset.allVisible = 'true';
        this.expandExtraItems();
      }
    }
  
  expandExtraItems() {
    this.items.forEach((item) => {
      // 只展开有 data-expanded="false" 的项
      if (item.dataset.expanded !== 'false') {
        return;
      }
      
      const currentTransition = item.style.transition;
      item.style.transition = 'none';
      item.style.maxHeight = 'none';

      
      const height = item.scrollHeight;
      
      item.style.maxHeight = '0';
      
      item.offsetHeight;
      
      item.style.transition = currentTransition;
      
      item.style.maxHeight = height + 'px';
      item.dataset.expanded = 'true';

      setTimeout(() => {
        if (this.content && this.content.dataset.allVisible === 'true') {
          item.style.maxHeight = 'none';
        }
      }, 500);
    });
  }
  
  initializeItems() {
    // 初始化已经通过 CSS 和 data-expanded 属性处理
    // 这里不需要额外操作
  }

  collapseExtraItems() {
    this.items.forEach((item) => {
      if (item.dataset.expanded === 'false') {
        // 保持隐藏状态
        return;
      }
      
      // 如果是需要折叠的项（没有 data-expanded 属性的说明是前5个）
      if (!item.hasAttribute('data-expanded')) {
        return;
      }
      
      // 折叠动画
      const currentHeight = item.scrollHeight;
      item.style.maxHeight = currentHeight + 'px';
      
      item.offsetHeight;
      
      item.style.maxHeight = '0';
      item.dataset.expanded = 'false';
      
      // 动画结束后恢复隐藏状态
      setTimeout(() => {
        if (item.dataset.expanded === 'false') {
          item.style.opacity = '';
          item.style.visibility = '';
        }
      }, 500);
    });
  }
  
  
  recalculateExpandedItemsHeight() {
    if (!this.content) return;

    // 重新计算展开状态下的part高度
    if (this.content.dataset.allVisible === 'true') {
      this.items.forEach((item) => {
        if (item.dataset.expanded === 'true') {
          item.style.transition = 'none';
          item.style.maxHeight = 'none';
          const height = item.scrollHeight;
          item.style.maxHeight = height + 'px';
          item.offsetHeight;
          item.style.transition = '';
        }
      });
    }
  }
}
  
  customElements.define('dl-product-part-list-h', DLProductPartListH);
  
  